import { render, staticRenderFns } from "./Core.vue?vue&type=template&id=16262907&scoped=true&"
import script from "./Core.vue?vue&type=script&lang=js&"
export * from "./Core.vue?vue&type=script&lang=js&"
import style0 from "./Core.vue?vue&type=style&index=0&id=16262907&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16262907",
  null
  
)

export default component.exports